(function ($) {
  const $pricing_toggle = $(".js-pricing-toggle");
  const $pricing_tables = $(".pricing-table");
  const $pricing_table = $(".pricing-tables");

  $pricing_toggle.on("change", function () {
    pricingChange();
  });

  $(window).on("load", function () {
    if ($pricing_table.hasClass("pricing-tables--annual")) {
      pricingChange();
      $pricing_toggle.prop("checked", true);
    }
  });

  function pricingChange() {
    $pricing_tables.each(function () {
      var $price = $(this).find(".price").find("span");
      var $link = $(this).find("a");
      var $small = $(this).find(".price").find('small');

      if ( $small.text() == "/mo" ) {
        $small.text("/year");
      } else {
        $small.text("/mo");
      }

      var new_price = $(this).data("toggle-price");
      var new_url = $(this).data("toggle-url");
      var annual_price = $(this).data("annual-price");

      var current_price = $price.text();
      var current_url = $link.attr("href");

      $(this).data("toggle-price", current_price);
      $(this).data("toggle-url", current_url);

      $price.text(new_price);
      $link.attr("href", new_url);
    });
  }

  const donate_button = $('.js-custom-donation');
  const please_select = $('.js-please-select');
  const custom_donation = $('#custom-donation');
  
  donate_button.hide();
  
  custom_donation.on('load input', function() {
    if ( $(this).val() > 0 ) {
      donate_button.show();
    } else {
      donate_button.hide();
    }
  });

  donate_button.on('click', function(e) {
    var parent = $(this).closest('.pricing-table');
    var price = parent.find('#custom-donation').val();
    var href = $(this).attr('href');
    $(this).attr('href', href + '&price=' + price);

    if ( price <= 0) {
      e.preventDefault();
      please_select.addClass('active');
    }
  });
  


})(jQuery);
